/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-02 17:18:55
 * @LastEditors: caiqin.xie
 * @message: 当前博客关联的游戏
 */
import React from "react";
import BlogItem from "../../../components/BlogItem";
import styles from "../../index.module.scss";
import { IBlogItem } from "@/common/types";

interface IProps {
  ctry: string;
  words: Record<string, string>;
  gamesContent: IBlogItem; // 当前博客关联的游戏
}

const RelatedGame = (props:IProps) => {
  const {ctry, words, gamesContent} = props

  return (
    <>
      {gamesContent && (
        <div className={styles['blog-right-top']}>
          <h3>{words?.blog_game_title} {gamesContent?.title}</h3>
          {/* Related */}
          <div className={styles['blog-list']}>
            <BlogItem
              type='onlyTitle'
              blogData={gamesContent}
              className={styles['custom-blog']}
              picClassName={styles['custom-blog-pic']}
              itemClassName={styles['custom-blog-item']} />
          </div>
        </div>
      )}
    </>
  )
}
export default RelatedGame
